// snackbar messaging (e.g., "Click on the pins to view...")
export const SET_SNACKBAR_EXPIRATION = '@action/set_snackbar_expiration'; // Sets an expiration for showing the snackbar again in local storage
export const CLOSE_SNACKBAR = '@action/close_snackbar'; // button click to close snackbar

// initial available actions
export const SEARCH_THIS_AREA = '@action/search_this_area'; // button click to execute a new search based on the position of the map (new lat/long)
export const CLICK_PIN = '@action/click_pin'; // map pin click to select a location and open the provider drawer
export const OPEN_SORT_AND_FILTER = '@action/open_sort_and_filter'; // button click to open the sort and filter drawer

// deeplink actions
export const SET_CONTEXT_FROM_DEEPLINK = '@actions/set_context_from_deeplink'; // copy params from deeplink to their places in context

// actions inside sort and filter drawer
export const CLOSE_SORT_AND_FILTER = '@action/close_sort_and_filter'; // button click to close the sort and filter drawer
export const CLEAR_SEARCH_FILTERS = '@action/clear_search_filters'; // button click to clear all search filters
export const SELECT_SORT_OPTION = '@action/select_sort_option'; // button click to select a sort option (e.g. A-Z). also an option on the provider drawer
export const UPDATE_SEARCH_PARAMS = '@action/update_search_params'; // filter click to add/select a filter to the selected filters

// action inside the provider drawer
export const CLOSE_PROVIDER_DRAWER = '@action/close_provider_drawer'; // button click to close the provider drawer
export const LOAD_MORE_PROVIDERS = '@action/load_more_providers'; // button click to close the provider drawer
export const OPEN_BOOKING_CTA_MODAL = '@action/open_booking_cta_modal'; // button click to open the booking CTA modal (Book Appointment button)
export const TOGGLE_GLOBAL_AVAILABILITY_MODAL =
  '@action/toggle_global_availability_modal'; // button click to toggle the global availability modal
export const TOGGLE_PROVIDER_AVAILABILITY_MODAL =
  '@action/toggle_provider_availability_modal'; // button click to toggle the provider (local) availability modal (TODO: do we have global AND local on map search?)

// actions inside the booking CTA modal
export const CLOSE_BOOKING_CTA_MODAL = '@action/close_booking_cta_modal'; // button click to close the booking CTA modal
export const CLICK_BOOK_BUTTON = '@action/click_book_button'; // button click inside the booking CTA modal to Book Appointment (TODO: do we need this?)

// actions inside the availability tiles modal
export const CLOSE_AVAILABILITY_MODAL = '@action/close_availability_modal'; // button click to close/dismiss the availability tiles modal
export const SELECT_PATIENT_REL = '@action/select_patient_rel'; // button click to select the patient relationship inside the availability tiles modal
export const SELECT_APPOINTMENT_PURPOSE = '@action/select_appointment_purpose'; // button click to select the appointment purpose inside the availability tiles modal
export const SET_AVAILABILITY_OPTIONS = '@action/set_availability_options'; // button click to close the availability tiles modal and show the results of selecting a relationship and purpose

// non-user actions used inside the machine
export const SET_PROVIDERS = '@action/set_providers'; // set providers into context
export const SET_LOCATIONS = '@action/set_locations'; // set locations into context
export const SET_PROVIDERS_AND_LOCATIONS =
  '@action/set_providers_and_locations'; // set providers AND locations into context
export const SET_SELECTED_LOCATION = '@action/set_selected_location'; // set the selected location into context following pin click
export const UNSET_SELECTED_LOCATION = '@action/unset_selected_location'; // unset the selected location from context following drawer close
export const SET_PROVIDERS_FOR_DRAWER = '@action/set_providers_for_drawer'; // set the providers to be displayed in the provider drawer (given filters, etc.)
export const LOAD_MORE_PROVIDERS_INTO_DRAWER =
  '@action/load_more_providers_into_drawer'; // append more providers to the providers already in the drawer
export const INCREMENT_PROVIDER_PAGE_NUM =
  '@action/increment_provider_page_num'; // increment the number of pages to load in the provider drawer (load more)
export const RESET_PROVIDER_PAGE_NUM = '@action/reset_provider_page_num'; // reset the number of provider pages to load in the drawer to 1
export const SET_HAS_MORE_PROVIDERS_TO_LOAD =
  '@action/set_has_more_providers_to_load'; // set a boolean to tell us if there are more providers to load (load more)
export const UPDATE_SEARCH_CENTER_AND_RADIUS =
  '@action/update_search_center_and_radius'; // click the search this area button

// TODO: uncliear if we actually need the below events:
export const BACK_TO_LIST_VIEW = '@action/back_to_list_view'; // button click to go back to list view (leave map search page)
export const DISMISS_INFO_SNACKBAR = '@action/dismiss_info_snackbar'; // button click to close/dismiss the info snackbar
export const VIEW_PROVIDERS_FOR_LOCATION =
  '@action/view_providers_for_location'; // mobile only, shows the providers in provider drawer for the selected location

// actions for the parallel machine
export const PROVIDERS_AND_LOCATION_FETCH_SUCCES =
  '@action/providers_and_locations_fetch_success'; // broadcast when a fetch for providers and location is successful
export const PROVIDER_DRAWER_CLOSED = '@action/provider_drawer_closed'; // broadcast sent by the machine when the drawer is actually closed
export const SORT_AND_FILTER_DRAWER_CLOSED =
  '@action/sort_and_filter_drawer_closed'; // broadcast sent by the machine when the drawer is actually closed

// Action when location pin is clicked when in mobile view for search map
export const LOCATION_PIN_CLICK = '@action/location_pin_click'; // map pin click to select a location and open the provider drawer

// actions for the map provider card which needs to be closed when clicked on backdrop
export const CLOSE_PROVIDER_CARD = '@action/close_provider_card'; // button click to close the provider drawer

// Actions to enable or diable search this area button
export const ENABLE_SEARCH_THIS_AREA = '@action/enable_search_this_area';
export const DISABLE_SEARCH_THIS_AREA = '@action/disable_search_this_area';
